const PathType = {
    DataSynchronization: 1,
    Reporting: 2,
    DataTable: 3,
    MetaApi: 4,
    AI: 5
} as const;

export default PathType; 
